import React from "react";
import { Skeleton } from "components/ui/skeleton";

/**
 * Skeleton loader for the API Keys / Distributor Keys section.
 * Mirrors the layout of DistributorKeyList cards (title, badge, key lines, button).
 */
const DistributorKeysSkeleton = () => {
  return (
    <div className="space-y-3" data-testid="distributor-keys-skeleton">
      {[1, 2].map((i) => (
        <div key={i} className="rounded-lg border border-slate-200 bg-slate-50/50 p-4" aria-hidden>
          {/* Card header: title + badge */}
          <div className="flex items-center justify-between border-b border-slate-200 pb-3">
            <Skeleton className="h-5 w-32 bg-gray-200" />
            <Skeleton className="h-5 w-14 rounded-full bg-gray-200" />
          </div>
          {/* Key lines + button row */}
          <div className="flex items-center justify-between gap-4 pt-3">
            <div className="space-y-2 flex-1">
              <Skeleton className="h-4 w-full max-w-[280px] bg-gray-200" />
              <Skeleton className="h-4 w-full max-w-[240px] bg-gray-200" />
              {i === 2 && <Skeleton className="h-4 w-full max-w-[200px] bg-gray-200" />}
            </div>
            <Skeleton className="h-9 w-24 shrink-0 rounded-md bg-gray-200" />
          </div>
        </div>
      ))}
    </div>
  );
};

export default DistributorKeysSkeleton;
